import { Controller } from "stimulus";

// Reports malformed JSON on the field and blocks the submit. Convenience only:
// the server validates shape against the schema and meaning against the plugin,
// and its verdict is the one that counts.
export default class extends Controller {
  static targets = ["value", "error"];

  connect() {
    this.validate();
  }

  validate() {
    const raw = this.valueTarget.value.trim();

    if (raw === "") {
      this.clear();
      return;
    }

    try {
      JSON.parse(raw);
      this.clear();
    } catch (error) {
      this.reject(error.message);
    }
  }

  clear() {
    this.errorTarget.textContent = "";
    this.valueTarget.classList.remove("is-invalid");
    this.setSubmitDisabled(false);
  }

  reject(message) {
    this.errorTarget.textContent = message;
    this.valueTarget.classList.add("is-invalid");
    this.setSubmitDisabled(true);
  }

  // Validity is per field, the submit button is per form. Writing the boolean
  // straight onto the button let a second object field re-enable the submit while
  // the first was still malformed, so the form tracks which fields are invalid and
  // the button only comes back when none is.
  setSubmitDisabled(disabled) {
    const form = this.element.closest("form");
    if (!form) return;

    const invalid = this.invalidFields(form);
    const key = this.valueTarget.name || this.valueTarget.id;
    if (disabled) invalid.add(key);
    else invalid.delete(key);

    const submit = form.querySelector('button[type="submit"]');
    // Left alone while saving is unavailable: BOOK-12 enables it, and until then
    // clearing an error must not turn it on.
    if (submit && !submit.dataset.savingUnavailable) submit.disabled = invalid.size > 0;
  }

  invalidFields(form) {
    if (!form.ancillaryObjectInvalid) form.ancillaryObjectInvalid = new Set();

    return form.ancillaryObjectInvalid;
  }
}
